import { Model } from 'modules/core/lib/mobx-rest'

interface ICompanyValue {
  id: string
  title: string
  description: string
}

class CompanyValue extends Model<ICompanyValue> {
  static urlRoot() {
    return '/ats/company_values'
  }
}

export default CompanyValue
